import React from "react";
import HandOutLists from "../components/veterinaryconditions/HandoutList";
import SearchBanner from "../components/veterinaryconditions/SearchBanner";
import "../styles/handout.css";

const HandOutDetails = () => (
  <div className="handoutMain">    
    <SearchBanner />
    <HandOutLists />
  </div>
);

export default HandOutDetails;
